const Index = () => import('./views/index.vue');

export default [
  {
    name: '404',
    path: '/404',
    component: Index,
    meta: { title: '风变课灵小馆' }
  }
];
